import React from "react";

export default function AppQrcode() {
  return <div>App QrCode</div>;
}
